import { pumatracApi } from '../utils/axios-config'

export default {
    following({id}) {
        return pumatracApi.get(`/profiles/${id}/following`, {})
    },

    profile({id}) {
        return pumatracApi.get(`/profiles/${id}`, {})
    }
}